/* SOLAR STYLE — foundation motion engine (solar.js)
   Drives [data-sv-reveal], [data-sv-parallax] and img.sv-loaded.
   Idempotent, defer-safe, respects prefers-reduced-motion. */
(function () {
  'use strict';

  if (window.__svFoundation) return;
  window.__svFoundation = true;

  var reducedMotion = false;
  try {
    reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {
    reducedMotion = false;
  }

  /* ---------- Scroll reveal ---------- */

  var revealObserver = null;

  function revealNow(el) {
    el.classList.add('sv-in');
  }

  function initReveal(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var els = scope.querySelectorAll('[data-sv-reveal]:not(.sv-in)');
    if (!els.length) return;

    if (reducedMotion || !('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) revealNow(els[i]);
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        for (var j = 0; j < entries.length; j++) {
          if (!entries[j].isIntersecting) continue;
          revealNow(entries[j].target);
          revealObserver.unobserve(entries[j].target);
        }
      }, { threshold: 0.15 });
    }

    for (var k = 0; k < els.length; k++) revealObserver.observe(els[k]);
  }

  /* ---------- Image load helper (for .sv-zoom settle) ---------- */

  function markLoaded(img) {
    img.classList.add('sv-loaded');
  }

  function initImages(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var imgs = scope.querySelectorAll('img.sv-zoom:not(.sv-loaded), [data-sv-reveal] img:not(.sv-loaded)');
    for (var i = 0; i < imgs.length; i++) {
      (function (img) {
        if (img.complete && img.naturalWidth > 0) {
          markLoaded(img);
          return;
        }
        img.addEventListener('load', function () { markLoaded(img); }, { once: true });
        img.addEventListener('error', function () { markLoaded(img); }, { once: true });
      })(imgs[i]);
    }
  }

  /* ---------- Parallax (subtle translateY, rAF-throttled) ---------- */

  var parallaxEls = [];
  var parallaxBound = false;
  var ticking = false;

  function collectParallax() {
    parallaxEls = Array.prototype.slice.call(document.querySelectorAll('[data-sv-parallax]'));
  }

  function updateParallax() {
    ticking = false;
    var vh = window.innerHeight || 0;
    if (!vh) return;
    for (var i = 0; i < parallaxEls.length; i++) {
      var el = parallaxEls[i];
      var rate = parseFloat(el.getAttribute('data-sv-parallax'));
      if (isNaN(rate) || rate === 0) rate = 0.15;
      var rect = el.getBoundingClientRect();
      if (rect.bottom < -80 || rect.top > vh + 80) continue;
      var offset = (rect.top + rect.height / 2 - vh / 2) * -rate;
      el.style.transform = 'translate3d(0, ' + offset.toFixed(1) + 'px, 0)';
    }
  }

  function requestParallax() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateParallax);
  }

  function initParallax() {
    if (reducedMotion) return;
    collectParallax();
    if (!parallaxEls.length) return;
    if (!parallaxBound) {
      parallaxBound = true;
      window.addEventListener('scroll', requestParallax, { passive: true });
      window.addEventListener('resize', requestParallax);
    }
    requestParallax();
  }

  /* ---------- Boot ---------- */

  function init(root) {
    initReveal(root);
    initImages(root);
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Theme editor: re-scan when sections are (re)rendered */
  document.addEventListener('shopify:section:load', function (evt) {
    init(evt.target || document);
  });
})();
